import { Box } from "@mui/system";
import BrandsTabs from "./BrandsTabs";

const Brands = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <BrandsTabs />
      </Box>
    </>
  );
};

export default Brands;
